import { styled } from "@mui/material";
import {
  DataGridPro as MuiDataGrid,
  DataGridProProps as MuiDataGridProps,
} from "@mui/x-data-grid-pro";

const StyledDataGrid = styled(MuiDataGrid)(() => ({
  // ... existing styles
}));

type DataGridProps = MuiDataGridProps;

export const DataGrid: React.FC<DataGridProps> = ({ ...props }) => {
  return <StyledDataGrid {...props} />;
};

export default DataGrid;
